import script from "./InquiryDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InquiryDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./InquiryDetailPage.vue?vue&type=style&index=0&id=318f0422&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318f0422"]])

export default __exports__